import { Box } from '@mui/material';
import GoogleAdSense, { AD_SLOT } from './GoogleAdSense';
import { AD_TYPE, PAGE_TYPE } from '../../constants/gaEnums';

const SLOT_BY_PAGE = {
  [PAGE_TYPE.NOTIFICATION]: AD_SLOT.NOTIFICATION_RIGHT_STICKY,
  [PAGE_TYPE.NOTICE_MAIN]: AD_SLOT.NOTICE_RIGHT_STICKY_1,
};

const SidebarWideAd = ({ pageType }) => (
  <Box
    sx={{
      display: { xs: 'none', lg: 'block' },
      width: 380,
      flexShrink: 0,
      px: '40px',
    }}
  >
    <Box sx={{ position: 'sticky', top: 80, display: 'flex', justifyContent: 'center' }}>
      <GoogleAdSense
        adSlot={SLOT_BY_PAGE[pageType]}
        adType={AD_TYPE.SIDEBAR_300_600}
        pageType={pageType}
        sx={{ width: 300, height: 600 }}
      />
    </Box>
  </Box>
);

export default SidebarWideAd;
